(function () {
  const selectors = {
    input: "[data-nosto-element='search-input']",
    list: "[data-nosto-element='autocomplete']",
    option: "[data-nosto-element='keyword']"
  };

  let frame = 0;

  function visibleOptions() {
    return [...document.querySelectorAll(selectors.option)].filter((option) => option.offsetParent !== null);
  }

  function promoteHeadings() {
    document.querySelectorAll(".ns-suggestions-heading, .ns-products-heading").forEach((node) => {
      if (node.tagName === "H2") return;

      const heading = document.createElement("h2");
      heading.className = node.className;
      heading.replaceChildren(...node.childNodes);
      node.replaceWith(heading);
    });
  }

  function enhance() {
    promoteHeadings();

    const list = document.querySelector(selectors.list);
    if (!list) return;

    if (!list.id) list.id = "SearchSuggestions";
    list.setAttribute("role", "listbox");
    list.setAttribute("aria-label", "Search suggestions");

    const wrapper = list.parentElement;
    if (wrapper && wrapper.getAttribute("tabindex") === "0" && !wrapper.getAttribute("role")) {
      wrapper.setAttribute("tabindex", "-1");
    }

    visibleOptions().forEach((option, index) => {
      option.setAttribute("role", "option");
      option.setAttribute("tabindex", "0");
      if (!option.id) option.id = "SearchSuggestion-" + index;

      if (option.dataset.keyboardBound === "true") return;

      option.dataset.keyboardBound = "true";
      option.addEventListener("keydown", onOptionKeydown);
    });

    document.querySelectorAll(selectors.input).forEach((input) => {
      const expanded = visibleOptions().length > 0;
      input.setAttribute("role", "combobox");
      input.setAttribute("aria-autocomplete", "list");
      input.setAttribute("aria-expanded", expanded.toString());
      input.setAttribute("aria-controls", list.id);

      if (input.dataset.keyboardBound === "true") return;

      input.dataset.keyboardBound = "true";
      input.addEventListener("keydown", onInputKeydown);
    });
  }

  function onInputKeydown(event) {
    const options = visibleOptions();
    if (!options.length) return;

    if (event.key === "ArrowDown") {
      event.preventDefault();
      options[0].focus();
    }

    if (event.key === "Escape") {
      event.currentTarget.setAttribute("aria-expanded", "false");
    }
  }

  function onOptionKeydown(event) {
    const option = event.currentTarget;

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      option.click();
      return;
    }

    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      moveFocus(option, event.key === "ArrowDown" ? 1 : -1);
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      const input = option.closest("form")?.querySelector(selectors.input) || document.querySelector(selectors.input);
      input?.focus();
    }
  }

  function moveFocus(current, direction) {
    const options = visibleOptions();
    const next = options[options.indexOf(current) + direction];

    if (next) {
      next.focus();
      return;
    }

    if (direction < 0) {
      const input = current.closest("form")?.querySelector(selectors.input) || document.querySelector(selectors.input);
      input?.focus();
    }
  }

  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(enhance);
  }

  if (document.body) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
  }
})();